module.exports = __webpack_public_path__ + "img/IMG_8164.7f0200cd.jpg";